import { useState } from 'react';
import { Box, Checkbox, Collapse, Typography } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAppDispatch, useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { getEnvProduct } from '@acorn-portal/shared/src/utils/get-env-product';
import { updatePrintToPost } from '@acorn-portal/shared/src/store/contactPreferences.slice';
import { useFeatureFlagEnabled } from 'posthog-js/react';

const PostalDocuments: React.FC = () => {
	const dispatch = useAppDispatch();

	const sendByPostVal = useAppSelector((state) => state.contactPreferences.printToPost);
	const state = useAppSelector((redux) => redux.midTermAdjustment);
	const isPrintToPostEnabled = useFeatureFlagEnabled(`${getEnvProduct().toLowerCase()}_print_to_post`); //TODO: extract this to parent use cases and conditionally render instead
	const [isSelected, setIsSelected] = useState<boolean>(false);
	const [sendByPost, setSendByPost] = useState<boolean>(Boolean(sendByPostVal));

	const handleCheckboxChange = (checked: boolean) => {
		setSendByPost(checked);
		dispatch(updatePrintToPost(checked));
	};

	const handleExpand = () => {
		setIsSelected((prev) => !prev);
	};

	const company = getEnvProduct().toLowerCase();
	const isFutureDated: boolean = state.isMtaFutureDated;

	if (
		!isPrintToPostEnabled &&
		(['flag', 'motorcade', 'streetcover'].includes(company) || (isFutureDated && state.changeOfAddress))
	) {
		return null;
	}

	return (
		<Box>
			<Box>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'left',
						flexDirection: 'row',
						alignItems: 'left',
					}}
				>
					<Typography variant='subtitle1' sx={{ mb: 1, textAlign: 'left' }}>
						We can also send your documents in the post, this will take 3-5 working days. Please click{' '}
						<Typography color='secondary' component='span' onClick={handleExpand} sx={{ cursor: 'pointer' }}>
							here
						</Typography>
					</Typography>
				</Box>
				<Collapse in={isSelected}>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-start',
							flexDirection: 'row',
							width: '100%',
							alignItems: 'center',
						}}
					>
						<Checkbox
							icon={<CircleOutlinedIcon />}
							checkedIcon={<CheckCircleIcon />}
							name='sendWelcomePack'
							id='sendWelcomePack'
							checked={sendByPost}
							onChange={(_, v) => {
								handleCheckboxChange(v);
							}}
							sx={{
								'& .MuiSvgIcon-root': { fontSize: '4rem' },
							}}
						/>
						<Typography>Please send me a copy of my documents in the post</Typography>
					</Box>
				</Collapse>
			</Box>
		</Box>
	);
};

export default PostalDocuments;
